<template>

  <div>
    <estimate-details-modal :details="estimationDetails" :clientsId="{id:estimationInfo.client_id}" :tax="{taxIncluded:taxIncluded, taxRate:taxRate}"/><!-- VAT -->
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'><router-link to='/new-estimates'>{{translations('navbar.sale_management')}}</router-link></li>
        <li class='breadcrumb-item'><router-link to='/archive-estimates'>{{translations('estimate.archive_estimate')}}</router-link></li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('estimate.register_estimate')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <div class='form-inline mb-4'>
            <div class='form-group mr-2'>
              <button class='btn btn-primary disabled'>{{translations('estimate.order_processing')}}</button>
            </div>
          </div>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('estimate.estimated_at')}}</th>
                <td>
                    <button ref="info01" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info01' data-placement='right'>--------------</button>
                    <div id='popover-info01' class='popover popover-x popover-default'>
                      <div class='arrow'></div>
                      <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.estimated_at')}}</div>
                      <div class='popover-body popover-content'>
                        <input type='date' v-model="temp.estimated_at" class='form-control'>
                      </div>
                      <div class='popover-footer'>
                        <button type='submit' v-on:click="updateField('estimated_at', temp.estimated_at, 'info01')" class='btn btn-sm btn-primary'>OK</button>
                      </div>
                    </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('estimate.name')}}</th>
                <td>
                    <button ref="info02" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info02' data-placement='right'>--------------</button>
                    <div id='popover-info02' class='popover popover-x popover-default resize'>
                      <div class='arrow'></div>
                      <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.name')}}</div>
                      <div class='popover-body popover-content'>
                        <textarea v-model="temp.name" class='form-control horizontal-only' rows="1"></textarea>
                      </div>
                      <div class='popover-footer'>
                          <button type='submit' v-on:click="updateField('name', temp.name, 'info02')" class='btn btn-sm btn-primary'>OK</button>
                      </div>
                    </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('estimate.estimate_number')}}</th>
                <td>
                    <button ref="info03" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info03' data-placement='right'>--------------</button>
                    <div id='popover-info03' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                      <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.estimate_number')}}</div>
                      <div class='popover-body popover-content'>
                        <input ref="input-info03" type='text' v-model="temp.estimate_number" class='form-control'>
                      </div>
                      <div class='popover-footer'>
                        <button type='submit' v-on:click="updateField('estimate_number', temp.estimate_number, 'info03')" class='btn btn-sm btn-primary'>OK</button>
                      </div>
                    </div>
                </td>
              </tr>
              <tr>
                  <th>{{translations('estimate.supplier')}}</th>
                  <td>
                    <button ref="info04" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info04' data-placement='right'>--------------</button>
                    <div ref="popover-info04" id='popover-info04' class='popover popover-x popover-default popover-fit-content'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.supplier')}}</div>
                        <div class='popover-body popover-content'>
                          <v-select :options="clients" label="name" value="id" v-model="temp.client_id"></v-select>
                        </div>
                        <div class='popover-footer'>
                          <button type='submit' v-on:click="updateField('client_id', temp.client_id, 'info04')" class='btn btn-sm btn-primary'>OK</button>
                        </div>
                    </div>
                  </td>
              </tr>
              <tr>
                  <th>{{translations('estimate.destination_name')}}</th>
                  <td>
                      <button ref="info05" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info05' data-placement='right'>--------------</button>
                      <div id='popover-info05' class='popover popover-x popover-default popover-fit-content'>
                          <div class='arrow'></div>
                          <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.destination_name')}}</div>
                          <div class='popover-body popover-content'>
                            <v-select :options="destinations" label="name" value="id" v-model="temp.destination_id"></v-select>
                          </div>
                          <div class='popover-footer'>
                              <button type='submit' v-on:click="updateField('destination_id', temp.destination_id, 'info05')" class='btn btn-sm btn-primary'>OK</button>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <th>{{translations('estimate.contact_person')}}</th>
                  <td>
                      <button ref="info06" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info06' data-placement='right'>--------------</button>
                      <div id='popover-info06' class='popover popover-x popover-default'>
                          <div class='arrow'></div>
                          <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.contact_person')}}</div>
                          <div class='popover-body popover-content'>
                              <input type='text' v-model="temp.end_users" class='form-control'>
                          </div>
                          <div class='popover-footer'>
                              <button type='submit' v-on:click="updateField('end_users', temp.end_users, 'info06')" class='btn btn-sm btn-primary'>OK</button>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <th>{{translations('estimate.delivery_time')}}</th>
                  <td>
                      <button ref="info07" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info07' data-placement='right'>{{ estimationInfo.quotation_delivery_time ? estimationInfo.quotation_delivery_time : '--------------' }}</button>
                      <div id='popover-info07' class='popover popover-x popover-default'>
                          <div class='arrow'></div>
                          <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.delivery_time')}}</div>
                          <div class='popover-body popover-content'>
                              <input type='text' v-model="temp.quotation_delivery_time" class='form-control'>
                          </div>
                          <div class='popover-footer'>
                              <button type='submit' v-on:click="updateField('quotation_delivery_time', temp.quotation_delivery_time, 'info07')" class='btn btn-sm btn-primary'>OK</button>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <th>{{translations('estimate.transaction_system')}}</th>
                  <td>
                      <button ref="info08" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info08' data-placement='right'>{{ estimationInfo.quotation_transaction_system ? estimationInfo.quotation_transaction_system : '--------------' }}</button>
                      <div id='popover-info08' class='popover popover-x popover-default'>
                          <div class='arrow'></div>
                          <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.transaction_system')}}</div>
                          <div class='popover-body popover-content'>
                              <input type='text' v-model="temp.quotation_transaction_system" class='form-control'>
                          </div>
                          <div class='popover-footer'>
                              <button type='submit' v-on:click="updateField('quotation_transaction_system', temp.quotation_transaction_system, 'info08')" class='btn btn-sm btn-primary'>OK</button>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <th>{{translations('estimate.expiry_date')}}</th>
                  <td>
                      <button ref="info09" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info09' data-placement='right'>{{ estimationInfo.quotation_expiration_date ? estimationInfo.quotation_expiration_date : '--------------' }}</button>
                      <div id='popover-info09' class='popover popover-x popover-default'>
                          <div class='arrow'></div>
                          <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.expiry_date')}}</div>
                          <div class='popover-body popover-content'>
                              <input type='text' v-model="temp.quotation_expiration_date" class='form-control'>
                          </div>
                          <div class='popover-footer'>
                              <button type='submit' v-on:click="updateField('quotation_expiration_date', temp.quotation_expiration_date, 'info09')" class='btn btn-sm btn-primary'>OK</button>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <th>{{translations('estimate.remarks')}}</th>
                  <td>
                      <button ref="info10" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info10' data-placement='right'>--------------</button>
                      <div id='popover-info10' class='popover popover-x popover-default resize'>
                          <div class='arrow'></div>
                          <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.remarks')}}</div>
                          <div class='popover-body popover-content'>
                              <textarea class="form-control" v-model="temp.memo"></textarea>
                          </div>
                          <div class='popover-footer'>
                              <button type='submit' v-on:click="updateField('memo', temp.memo, 'info10')" class='btn btn-sm btn-primary'>OK</button>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <th>{{translations('estimate.manager')}}</th>
                  <td>
                      <button ref="salesman_name" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-salesman_name' data-placement='right'>--------------</button>
                      <div id='popover-salesman_name' class='popover popover-x popover-default'>
                          <div class='arrow'></div>
                          <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{translations('estimate.manager')}}</div>
                          <div class='popover-body popover-content'>
                              <input type='text' v-model="temp.salesman_name" class='form-control'>
                          </div>
                          <div class='popover-footer'>
                              <button type='submit' v-on:click="updateField('salesman_name', temp.salesman_name, 'salesman_name')" class='btn btn-sm btn-primary'>OK</button>
                          </div>
                      </div>
                  </td>
              </tr>
          </tbody>
          </table>
          <hr>
          <div class='form-inline'>
            <div class='form-group mr-2'>
              <button class='btn btn-danger disabled'>{{translations('estimate.lost_order_processing')}}</button>
            </div>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger disabled' href='#'>{{translations('common.delete')}}</a>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{translations('common.tax_included')}}</div><!-- TAXSTATUS -->
            <div v-else>{{translations('common.tax_excluded')}}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1100'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{translations('estimate.jan_code')}}</th>
                  <th>{{translations('estimate.model')}}</th>
                  <th>{{translations('estimate.tax_classification')}}</th><!-- TAXSTATUS -->
                  <th>{{translations('estimate.quantity')}}</th>
                  <th>{{translations('estimate.unit_price')}}</th>
                  <th>{{translations('estimate.product_cost')}}</th>
                  <th>{{translations('estimate.remarks')}}</th>
                  <th>{{translations('estimate.unit_price_total')}}</th>
                  <th>{{translations('estimate.total_cost')}}</th>
                  <th>{{translations('estimate.total_profit')}}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for='(detail, i) in estimationDetails'>
                  <tr :key='i'>
                    <td>
                        <button @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td>{{ detail.jan_code }}</td>
                    <td>{{ detail.type_number }}</td>
                    <td>
                      <select
                       :disabled="false"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onchangeTaxclass"
                      >
                        <option value="1">{{ translations('estimate.taxable_item') }}</option>
                        <option value="2">{{ translations('estimate.not_applicable') }}</option>
                      </select>
                    </td><!-- TAXSTATUS -->
                    <td class="right">{{ Number(detail.quantity).toLocaleString() }}</td>
                    <td :class="Number(detail.unit_price) < Number(detail.row_price) ? 'red-color right' : 'right'">{{ toTaxFormat(detail, 'unit_price') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'row_price') }}</td>
                    <td>{{ detail.remarks }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_cost') }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_profit') }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button class='btn-change plus' type='button' data-toggle='modal' data-target='#EstimateDetailsModal'><i></i></button>
                  </td>
                  <td></td><!-- TAXSTATUS -->
                  <td></td><td></td><td></td><td></td><td></td><td></td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalCost, grandTotalCostIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalProfit, grandTotalProfitIncTax) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group mr-2'>
              <button @click="addEstimate()" class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
            </div>
            <div class='form-group'>
              <a class='btn btn-link btn-sm decoration-underline disabled' href='#'>{{translations('estimate.estimate_PDF_output')}}<i class='fas fa-external-link-alt'></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EstimateDetailsModal from '@/components/EstimateDetailsModal'
import { mapState } from 'vuex'

export default {
  name: 'NewEstimates',
  props: {},
  components: {
    EstimateDetailsModal
  },
  data () {
    return {
      taxRate: 0, // VAT
      taxIncluded: false, // VAT
      estimationInfo: {
        destination_id: '',
        end_users: '',
        quotation_delivery_time: '',
        quotation_transaction_system: '',
        quotation_expiration_date: '',
        client_id: '',
        estimate_number: '',
        estimated_at: '',
        name: '',
        memo: ''
      },
      estimationDetails: [],
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalCost: 0,
      grandTotalCostIncTax: 0,
      grandTotalProfit: 0,
      grandTotalProfitIncTax: 0,
      temp: {
        destination_id: '',
        end_users: '',
        quotation_delivery_time: '',
        quotation_transaction_system: '',
        quotation_expiration_date: '',
        client_id: '',
        estimate_number: '',
        estimated_at: '',
        name: '',
        memo: ''
      },
      destinations: [],
      isParamReady: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    clients () {
      return this.$store.getters['Master/getBillTo']
    },
    confirmationAddEstimateMessage () {
      return this.translations('estimate.save_estimate')
    },
    confirmButtonText () {
      return this.translations('common.yes')
    },
    cancelButtonText () {
      return this.translations('common.no')
    }
  },
  watch: {
    estimationDetails: {
      handler (v) {
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })
        this.calcGrandTotals()
      },
      deep: true
    },
    'estimationInfo.client_id' (newId, oldId) {
      this.updateField('destination_id', '', 'info05')
      this.listDestinations()
    },
    currentLanguage (newLang) {
      this.estimationInfo.quotation_delivery_time = this.translations('estimate.quotation_delivery_time')
      this.estimationInfo.quotation_transaction_system = this.translations('estimate.quotation_transaction_system')
      this.estimationInfo.quotation_expiration_date = this.translations('estimate.quotation_expiration_date')
      this.temp.quotation_delivery_time = this.translations('estimate.quotation_delivery_time')
      this.temp.quotation_transaction_system = this.translations('estimate.quotation_transaction_system')
      this.temp.quotation_expiration_date = this.translations('estimate.quotation_expiration_date')
    }
  },
  mounted () {
    this.estimationInfo.quotation_delivery_time = this.translations('estimate.quotation_delivery_time')
    this.estimationInfo.quotation_transaction_system = this.translations('estimate.quotation_transaction_system')
    this.estimationInfo.quotation_expiration_date = this.translations('estimate.quotation_expiration_date')
    this.temp.quotation_delivery_time = this.translations('estimate.quotation_delivery_time')
    this.temp.quotation_transaction_system = this.translations('estimate.quotation_transaction_system')
    this.temp.quotation_expiration_date = this.translations('estimate.quotation_expiration_date')
  },
  created () {
    this.$store.dispatch('Master/checkBillTo')
    Promise.all([
      this.getTaxRate(),
      this.getSequence()
    ]).then(() => {
      this.popoverButtons()
    }).catch(error => {
      this.$toastr.error(error, 'エラー')
    })
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    async listDestinations () {
      try {
        let cList = await this.$http.post(
          this.$api_url.destinations_list,
          { client_id: this.estimationInfo.client_id }
        )
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'NewEstimates:listDestinations')
        if ($data.success === true) {
          this.destinations = $data.data
        } else {
          this.destinations = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('NewEstimates:listDestinations:catch(error): ', error)
        this.$toastr.error(this.translations('estimate.notice_failed'), this.translations('common.error'))
      }
    },
    getSequence () {
      this.$http.post(this.$api_url.estimates_sequence).then(response => {
        const result = response.data
        if (result.status === true) {
          this.temp.estimate_number = result.sequence
          this.estimationInfo.estimate_number = result.sequence
          this.$refs['info03'].innerText = result.sequence
          this.$refs['input-info03'].value = result.sequence
        }
      }).catch(error => {
        console.log('NewEstimates:getSequence:catch(error): ', error)
        return Promise.reject(error)
      })
    },
    getTaxRate () {
      this.$http.post(this.$api_url.vat_rate).then(response => {
        const result = response.data
        if (result.status === true) {
          this.taxRate = result.vat_rate
        } else {
          this.$refs['defaultCheckTax'].disabled = true
          return Promise.reject(new Error(this.translations('estimate.notice_tax_rate')))
        }
      }).catch(error => {
        console.log('NewEstimates:getTaxRate:catch(error): ', error)
        return Promise.reject(error)
      })
    },
    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()} (${Number(valIncTax).toLocaleString()})`
      } else {
        return `${Number(valIncTax).toLocaleString()} (${Number(val).toLocaleString()})`
      }
    },
    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
        if (taxIncluded) {
          return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
        } else {
          return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
        }
      } else {
        if (!taxIncluded) { // 税込以外
          return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
        } else {
          return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
        }
      }
    },

    prepareDetails (data, hasCost = false) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price
      data.total_profit = data.total_unit_price - data.total_cost

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
        data.total_profit_inctax = data.total_profit
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
        data.total_profit_inctax = this.$util.getIncludeTax(data.total_profit, data.tax_rate)
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalUnitPriceIncTax = 0
      this.grandTotalCost = 0
      this.grandTotalCostIncTax = 0
      this.grandTotalProfit = 0
      this.grandTotalProfitIncTax = 0

      this.estimationDetails.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
        this.grandTotalCost += Number(v.total_cost)
      })

      this.grandTotalProfit = this.grandTotalUnitPrice - this.grandTotalCost

      this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
      this.grandTotalCostIncTax = this.$util.getIncludeTax(this.grandTotalCost, this.taxRate)
      this.grandTotalProfitIncTax = this.grandTotalUnitPriceIncTax - this.grandTotalCostIncTax
    },

    /**
     * @param field : estimate information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref) {
      console.log(ref, ':field: ', field)
      let $this = this
      let val = ''
      const rg = /^\s+$/
      if (!value || value === '-' || value === '' || rg.test(value) === true || typeof value === 'undefined') {
        if (field === 'estimated_at') {
          $this.$refs[ref].innerText = '--------------'
        } else {
          $this.$refs[ref].innerText = '--------------'
        }
        val = ''
      } else if (field === 'client_id') {
        this.clients.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
            $this.taxIncluded = Number(v.taxstatus) === 2 // 0:未設定(税抜), 1:税抜, 2:税込 // TAXSTATUS
          }
        })
      } else if (field === 'destination_id') {
        val = 0 // DEFAULT // WARNING: DBがint型のため''ではエラーが発生する場合、該当selectのデフォルト値に0をセットし、比較対象が0件でも0になるよう初期値に0をセット
        this.destinations.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'estimated_at') {
        const x = /-/gi
        $this.$refs[ref].innerText = value.replace(x, '/')
        val = value.replace(x, '/')
      } else {
        $this.$refs[ref].innerText = value
        val = value
      }
      $this.estimationInfo[field] = val
      console.log('NewEstimates:updateField: ', $this.estimationInfo)
      window.$('#popover-' + ref).popoverX('hide')
    },

    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    deleteDetail (i) {
      this.estimationDetails.splice(i, 1)
    },

    addEstimate () {
      if (this.estimationDetails.length === 0) {
        this.$toastr.warning(this.translations('estimate.notice_enter_details_line'))
        return
      }
      let $this = this
      this.$dialog.confirm(this.confirmationAddEstimateMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      }).then(async () => {
        try {
          // 備考の改行数をチェック
          if ($this.estimationInfo.memo && $this.estimationInfo.memo.split('\n').length > 5) {
            this.$toastr.error(this.translations('estimate.notice_enter_remark_line'), this.translations('estimate.error'))
            return
          }

          // const taxRate = Number(this.taxRate)

          $this.estimationDetails.forEach(function (item) {
            item.row_price = String(item.row_price) // String for Phalcon(DECIMAL10,2)

            //   if (!$this.taxIncluded) {
            //     item.unit_price_inctax = $this.$util.getIncludeTax(item.unit_price, taxRate)
            //   }
            //   item.tax_rate = taxRate
          })
          $this.estimationInfo.division_type = 'D'
          let paramAdd = {
            information: $this.estimationInfo,
            details: $this.estimationDetails
          }
          paramAdd.information.estimation_status = 1
          let add = await this.$http.post(this.$api_url.add_estimate, paramAdd)
          let $data = this.$invoiceTools.prepareResult(add.data, 'list', 'NewEstimates:API:addEstimate:posData')
          if ($data.success === true) {
            $this.$router.replace('archive-estimates')
            $this.$toastr.success(this.translations('estimate.notice_success'), this.translations('common.success'))
          } else {
            this.clients = [{ id: 0, name: 'No record.' }]
            this.$toastr.error($data.data, this.translations('common.error'))
          }
        } catch (error) {
          console.log('NewEstimates:addEstimate:catch(error): ', error)
          this.$toastr.error(this.translations('estimate.notice_failed'), this.translations('common.error'))
        }
      })
    },
    onchangeTaxclass () {
      this.estimationDetails.forEach((detail, i) => {
        if (typeof detail !== 'undefined') {
          // this.ordersDetails[i] = this.prepareDetails(detail)
          this.estimationDetails[i] = this.prepareDetails(detail)
        }
      })
      this.calcGrandTotals()
    }
  }
}
</script>
